import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta, launchOffer } from '../data/content';
export function FinalCta() {
  return <section className="border-t border-night-line bg-night" data-id="element-50" data-mp="vh0na7qejbmo">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:px-6 lg:py-24" style={{
      paddingBottom: "0px"
    }} data-id="element-51" data-mp="19f7cz0l765b9">
        <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
        fontSize: "32px"
      }} data-id="element-52" data-mp="15cklj0sfumel">
          Empezá a recorrer la Biblia con una ruta clara
        </h2>
        <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-parchment/70 sm:text-lg" data-id="element-53" data-mp="1eds7cjdrpurs">
          Accedé a los 73 mapas visuales de GPS Bíblico y descubrí una manera más clara y
          ordenada de comprender cada libro de la Biblia Católica.
        </p>
        <p className="mx-auto mt-3 max-w-xl font-sans text-base leading-relaxed text-parchment/70 sm:text-lg" data-id="element-54" data-mp="2245ze9wcrtmd">
          Además, hoy recibís los 5 bonos sin costo adicional.
        </p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-55" data-mp="n6nr2ye1q4ws">
          <p className="font-sans text-base text-parchment/45 line-through" data-id="element-56" data-mp="n7yugx3kxand">
            {launchOffer.regularPrice}
          </p>
          <p className="font-display text-4xl font-semibold text-gold-soft sm:text-5xl" data-id="element-57" data-mp="x38x9n1sxm27">
            <span className="text-2xl" data-id="element-58" data-mp="123ejuot7sidf">HOY </span>
            {launchOffer.price}
          </p>
          <p className="mt-1 font-sans text-sm font-semibold text-gold" data-id="element-59" data-mp="164qamxntr9n7">
            GPS Bíblico + 5 bonos incluidos
          </p>
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-60" data-mp="1b1ywb886lvt7">
          <CtaButton size="block" href={checkoutUrl} data-id="element-61" data-mp="1fujoy6fcq2v5">
            {cta.short}
          </CtaButton>
          <p className="mt-3 font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-62" data-mp="1kt3cucdi9oq5">
            {launchOffer.paymentNote}
          </p>
          <p className="mt-1 font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-63" data-mp="1pth7msq3j268">
            {cta.finalMicrocopy}
          </p>
        </div>
      </div>
    </section>;
}